// extracted by mini-css-extract-plugin
var _1 = "Jbdmb";
var _2 = "B4Rjw";
var _3 = "OWbm2";
var _4 = "p6ea4";
export { _1 as "isConnected", _2 as "isOffline", _3 as "statusTag", _4 as "title" }
